import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo7/derechosdefinicion.png";
import Imagen2 from "../../../images/modulo7/deberesdefinicion.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 3.mp3";

const Actividad3 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "derechos" },
    ans2: { value: "", valid: "", correctValue: "deberes" },
  });
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[2];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo7.content[0].activities[3].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[3].path}`,
    titlePrev: `${modulo7.content[0].activities[1].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
          A continuación aparecen las definiciones de derechos y deberes. ¿Cuál
          es cuál? Escribe las palabras en el lugar que corresponde.
        </li>
      </ul>
      <div className="row">
        <div className="col-12 col-lg-10 ms-lg-5 ms-0">
          <img src={Imagen1} alt="Derechos" className="img-fluid" />
        </div>
        <div className="col-12 col-lg-10 ms-lg-5 ms-0">
          <Card>
            <div className="d-flex flex-wrap align-items-center">
              <div className="d-inline-block">
                Todos los peruanos y peruanas tenemos
              </div>
              <input
                type="text"
                className={
                  "form-control mt-1 ms-2 d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
              <div className="d-inline-block">.</div>
              <div>
                {" "}
                Eso significa que podemos hacer ciertas cosas sin que nadie nos
                lo impida. Por ejemplo, podemos pertenecer a la religión de
                nuestra preferencia.
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-10 ms-lg-5 ms-0">
          <img src={Imagen2} alt="Deberes" className="img-fluid mt-5" />
        </div>
        <div className="col-12 col-lg-10 ms-lg-5 ms-0">
          <Card>
            <div className="d-flex flex-wrap align-items-center">
              <div className="d-inline-block">
                Todos los peruanos y peruanas tenemos
              </div>
              <input
                type="text"
                className={
                  "form-control mt-1 d-inline-block w-200 ms-2 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              <div className="d-inline-block">.</div>{" "}
              <div className="d-inline-block">
                Eso significa que estamos obligados a hacer ciertas cosas y
                respetar las leyes. Por ejemplo, es nuestra obligación ayudar a
                nuestros padres cuando lo necesitan.
              </div>
            </div>
          </Card>
          <div className="d-flex w-100 justify-content-end mt-4">
            <button
              className={`btn btn-${modulo7.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las escenas y lean los textos.
          Describan lo que se observa en las escenas. La primera escena
          corresponde a los derechos y la segunda a los deberes.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
